import axios from 'services/http';
import { baseUrl } from 'services/http/base';

export type ErrorType = {
  error?: unknown;
};

export function isError<T>(res: T | ErrorType): res is ErrorType {
  return (res as ErrorType)?.error !== undefined;
}

export function patchRequest<R extends object>(url: string, method: 'get' | 'post' = 'post', domainUrl = baseUrl) {
  return async function fetchData<T>(arg?: R, config?: object): Promise<T | ErrorType> {
    try {
      const res = await axios[method]<{ data: T }>(`${domainUrl}/${url}`, arg, config);
      if (res.code === 200) {
        return res.data;
      }
      return { error: res.msg };
    } catch (error) {
      return { error };
    }
  };
}
